"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[18229],{

/***/ 18229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var PaginationNextIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        viewBox: "0 0 9 14",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Page-1",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "Apple-TV-Copy-5",
                transform: "translate(-1197.000000, -3166.000000)",
                fill: "currentColor",
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "Group-7",
                    transform: "translate(696.000000, 3149.000000)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        id: "down-chevron-copy-9",
                        transform: "translate(505.500000, 24.000000) scale(-1, 1) rotate(-270.000000) translate(-505.500000, -24.000000) translate(499.000000, 20.000000)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                            id: "Path",
                            points: "10.8390244 0.0435360017 6.14400024 4.73856019 1.44897606 0.0435360017 0 1.49246406 6.14400024 7.6364643 12.2880005 1.49246406"
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PaginationNextIcon);


/***/ })

}]);